module.exports = __webpack_public_path__ + "static/media/bucket.545fd26b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/bucket.svg
// module id = 1526
// module chunks = 15